// SearchBox.js
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import {
    FormControl, InputLabel, InputAdornment, IconButton,
    Input,
    OutlinedInput
} from '@mui/material';
import { useId } from 'react';

const SearchBoxContainer = styled(Box)({
    display: 'inline-flex', alignItems: 'center',
});

export default function SearchBox({
    value,
    label,
    onChange: onChangeText,
    width, // if null, 300px
    onEnter, // trigger onEnter when user press Enter key and onEnter is not null.
    onClickSearch, // show search icon only if onClickSearch is not null
    disabled=false,
    style,
}) {

    const boxWidth = width ? width : 240;
    const InputID = useId();//'search-box-input';

    const onChangeSearch = (e) => {
        if(e.target.value) onChangeText(e.target.value.trim());
        else onChangeText('');
    };

    const onKeyDown = (e) => {
        if(e.key === 'Enter' && onEnter) onEnter();
    };

    const onClickSearchIcon = () => {
        if(onClickSearch) onClickSearch();
    };

    const newStyle = style ? style : {};
    newStyle.width = boxWidth;

    return(
        <SearchBoxContainer style={newStyle}>
            <FormControl variant='outlined' size='small'
                style={{flexGrow:1}}
            >
                <InputLabel htmlFor={InputID}
                    style={{
                        backgroundColor:'white', paddingTop:0
                    }}
                >{label||'검색'}</InputLabel>
                <OutlinedInput id={InputID} onChange={onChangeSearch} onKeyDown={onKeyDown}
                    value={value}
                    size='small'
                    disabled={disabled}
                    autoComplete='new-password'
                    endAdornment={
                        Boolean(value) ?
                        <InputAdornment position='end'>
                            <IconButton
                            onClick={()=>{onChangeText('')}}
                            size='small'
                            edge='end'
                            >
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                        :
                        null
                    }
                />
            </FormControl>
            {
                onClickSearch ?
                <IconButton
                    onClick={onClickSearchIcon}
                    size='small'
                >
                    <SearchIcon />
                </IconButton>
                : null
            }
        </SearchBoxContainer>
    );
}
